import React, {useEffect, useState} from 'react';
import {FaSearch} from 'react-icons/fa';
import {Modal} from '../../../../../components/modal/modal.jsx';
import {navigateHook} from '../../../../../hooks/use-navigate.js';
import ReportUtils from '../../../../../utils/report-utils.js';

const AbsenceDetailsContent = ({data}) => {
    const agents = Array.isArray(data?.agents) ? data.agents : [];
    const [open, setOpen] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const navigate = navigateHook();

    useEffect(() => {
        const summaryValues = agents.map(agent => ([
            agent.name,
            agent.namewar,
            agent.totalAbsences,
            agent.totalDaysOff,
            agent.lastAbsenceDate
        ]));

        ReportUtils.createExportableTable(['Nome', 'Nome de guerra', 'Total de ausências', 'Total de dias ausentes', 'Última ausência'], summaryValues, 'Detalhamento das ausências');

        const detailValues = agents.flatMap(agent => (
            Array.isArray(agent.details) ? agent.details.map(detail => ([
                agent.name,
                agent.namewar,
                detail.reason,
                detail.startDate,
                detail.endDate,
                detail.durationDays
            ])) : []
        ));

        ReportUtils.createExportableTable(['Nome', 'Nome de guerra', 'Motivo', 'Data inicial', 'Data final', 'Duração'], detailValues, 'Detalhes das ausências');
    }, [data]);

    const openDetails = (agent) => {
        setSelectedAgent(agent);
        setOpen(true);
    };

    const details = Array.isArray(selectedAgent?.details) ? selectedAgent.details : [];

    return (
        <div id="absence-details" className="print:break-inside-auto!">
            <div className="chart-report print:break-inside-auto!">
                <span className="chart-title">Detalhamento das ausências</span>

                { !agents.length ? (
                    <div className="alert alert-info p-2 h6 text-center mt-3">
                        Nenhum registro encontrado no período informado.
                    </div>
                ) : (
                    <div className="mt-3 mb-6">
                        <table id="absence-details-data" className="table report-table print:break-inside-auto!">
                            <thead className="thead-background print:table-row-group!">
                                <tr className="bg-[#f6f6f6] text-left">
                                    <th className="w-[24%]">Nome</th>
                                    <th className="w-[18%]">Nome de guerra</th>
                                    <th className="w-[18%]">Total de ausências</th>
                                    <th className="w-[20%]">Total de dias ausentes</th>
                                    <th className="w-[18%]">Última ausência</th>
                                    <th className="w-[2%] print:hidden"/>
                                </tr>
                            </thead>

                            <tbody className="bg-white">
                                { agents.map((agent, index) => {
                                    const hasDetails = Array.isArray(agent.details) && agent.details.length > 0;

                                    return (
                                        <tr key={`${agent.name ?? 'agent'}-${index}`}>
                                            <td className="w-[24%]">{agent.name ?? ''}</td>
                                            <td className="w-[18%]">{agent.namewar ?? ''}</td>
                                            <td className="w-[18%]">{agent.totalAbsences ?? 0}</td>
                                            <td className="w-[20%]">{agent.totalDaysOff ?? 0}</td>
                                            <td className="w-[18%]">{agent.lastAbsenceDate ?? ''}</td>
                                            <td className="w-[2%] print:hidden">
                                                <button
                                                    type="button"
                                                    className={`details-link ${!hasDetails ? 'opacity-25! cursor-not-allowed!' : ''}`}
                                                    title={`Ausências`}
                                                    onClick={() => hasDetails && openDetails(agent)}
                                                    disabled={!hasDetails}
                                                >
                                                    <FaSearch size={17}/>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            { open && selectedAgent && (
                <Modal open={open} setOpen={setOpen}  title={`${selectedAgent.name ?? ''} | ${selectedAgent.namewar ?? ''}`} isCloseClick={true} className={'w-[825px]'}>
                    <Modal.Body className="pt-0 !m-0 align-self-center justify-items-center">
                        <div className="w-full my-2">
                            { !details.length ? (
                                <div className="alert alert-info p-2 h6 text-center">
                                    Nenhum detalhe encontrado para este agente.
                                </div>
                            ) : (
                                <table className="table report-table my-2">
                                    <thead className="thead-background">
                                        <tr className="bg-[#f6f6f6] text-left">
                                            <th className="w-[38%]">Motivo</th>
                                            <th className="w-[22%]">Data inicial</th>
                                            <th className="w-[22%]">Data final</th>
                                            <th className="w-[18%]">Duração</th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-white">
                                        { details.map((detail, index) => (
                                            <tr key={`${detail.id ?? 'absence'}-${index}`}>
                                                <td className="w-[38%]">
                                                    {detail.id === null || detail.id === undefined ? (
                                                        detail.reason ?? ''
                                                    ) : (
                                                        <a onClick={() => navigate(`/absences/form/${detail.id}`, true)} className="inner-link">
                                                            {detail.reason ?? ''}
                                                        </a>
                                                    )}
                                                </td>
                                                <td className="w-[22%]">{detail.startDate ?? ''}</td>
                                                <td className="w-[22%]">{detail.endDate ?? ''}</td>
                                                <td className="w-[18%]">{detail.durationDays ?? 0}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </div>
    );
};

export default AbsenceDetailsContent;